export default {"src":"/_next/static/media/quotedown.4a647bfd.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};